import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './content-cards.component.scss';
var ContentCards = /** @class */ (function (_super) {
    tslib_1.__extends(ContentCards, _super);
    function ContentCards(element) {
        return _super.call(this, element) || this;
    }
    ContentCards.prototype.init = function () { };
    ContentCards.prototype.bindEvents = function () { };
    return ContentCards;
}(Base));
export { ContentCards };



//////////////////
// WEBPACK FOOTER
// ./components/content-cards/content-cards.component.ts
// module id = 221
// module chunks = 0